import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import { BACKEND_CONFIG } from "../../config/consts";

class Agencies extends Component {
  constructor() {
    super();

    this.state = {
      selectedAgencyId: null,
      loggedIn: false,
    };
  }

  render() {
    const { loggedIn } = this.state;
    let redirectUrl = this.props.clientId
      ? `/client/${this.props.clientId}`
      : "/home";

    return (
      <div>
        {loggedIn ? (
          <Redirect to={redirectUrl} />
        ) : (
          <div>
            <div className="modal-like" />
            <div className="login-page">
              <h2 className="text-white">Choose Your Agency</h2>
              <div
                className="container"
                style={{ width: "420px", borderRadius: "4px" }}
              >
                <div className="row">
                  <div className="float-right login-registered">
                    <div className="center-box">
                      <span className="text-center">
                        Select your agency below to get started.
                      </span>
                      <div
                        style={{
                          paddingTop: "10px",
                          paddingBottom: "30px",
                          paddingLeft: "8px",
                        }}
                      >
                        {this.props.agencies.map((agency, idx) => (
                          <div className="form-group" key={idx}>
                            <input
                              key={idx}
                              type="radio"
                              id={agency.AgencyId}
                              name="agencies"
                              value={agency.AgencyId}
                              style={{ marginRight: "8px" }}
                              checked={
                                this.state.selectedAgencyId === agency.AgencyId
                              }
                              onChange={(e) =>
                                this.setState({
                                  selectedAgencyId: e.target.value,
                                })
                              }
                            />

                            <label htmlFor={agency.AgencyId}>
                              {agency.AgencyName} ({agency.ExternalAgencyNumber}
                              )
                            </label>
                          </div>
                        ))}
                      </div>
                      <button
                        className="btn btn-primary w-100"
                        id="LogIn"
                        onClick={() => {
                          this.login();
                        }}
                        disabled={!this.state.selectedAgencyId}
                      >
                        Log In
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  login() {
    this.props.authenticate();
    BACKEND_CONFIG.set("agencyid", this.state.selectedAgencyId);
    this.setState({ loggedIn: true });
  }
}

export default Agencies;
